module.exports = __webpack_public_path__ + "img/egg-fried.713d9c42.svg";